import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import { isPresent } from '@ember/utils';

export interface GetNumberDifferenceSignature {
  Args: {
    Positional: [number | undefined, number | undefined];
  };
  Return: number | string | null;
}

/**
 * The default isPresent doesn't do type narrowing :(
 */
function isPresentNumber(value: number | undefined): value is number {
  return isPresent(value);
}

export default class GetNumberDifferenceHelper extends Helper<GetNumberDifferenceSignature> {
  @service declare intl: Services['intl'];

  compute([
    a,
    b,
  ]: GetNumberDifferenceSignature['Args']['Positional']): GetNumberDifferenceSignature['Return'] {
    if (isPresentNumber(a) && isPresentNumber(b)) {
      return a - b
        ? this.intl.formatNumber(a - b, { signDisplay: 'always' })
        : null;
    }
    return this.intl.t('general.not_available_short');
  }
}
